const projectsdata = [
    {title : "E.GraphicCardBuy.com",
    image : "./graphicCardProjects.jpg",
    description : " An ecommerce application developed using react , node , redux and mongoDB",
    link:"/https://nextgpucards-purchase.herokuapp.com/"
    },
    {
    title : "RollOver Game ",
    image : "game.png",
    description: "3d-game developed using unity engine with coding"
    },
    
    
    ];

    export default  projectsdata;